import React, { useEffect, useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import Card from '../controls/Card';
import ContainerTwo from '../base/ContainerTwo';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { GetAllByUser } from '../../configurations/crud/opdCentersCrud';
import { Dashboard } from '../../configurations/crud/reportCrud';
import moment from 'moment';
import StatusContainer from '../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../configurations/enums/EType';
import Getbalance from './rechargeHistory/Getbalance';
import { HiDocumentReport } from "react-icons/hi";
import Select from '../controls/Select';
import { FaClinicMedical } from "react-icons/fa";
import LoadingContainer from '../controls/LoadingContainer';
import useGlobalLoader from '../../configurations/useGlobalLoader';
import Empty from '../controls/Empty';

//const NEXT_MONTH = new Date();
//NEXT_MONTH.setMonth(NEXT_MONTH.getMonth() + 1);
const TODAY = new Date();

export default function DashBoard() {
    const { start, end } = useGlobalLoader()
    const [searchType, setSearchType] = useState(0);
    const [centerData, setCenterData] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(0);
    const initReport = {
        confirmedGlobal: [],
        confirmedSource: [],
        confirmedType: [],
        registeredGlobal: [],
    }
    const [reportData, setReportData] = useState(initReport);

    const toast = useToast()
    const [loding, setLoding] = useState(false)


    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: TODAY
    });


    useEffect(() => {
        getReport()
        getAllOpdCenters();
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (mdata.data.length > 0)
                        setCenterData(mdata.data);
                } else {
                    setCenterData([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setCenterData([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    function getReport() {
        setLoding(true);
        start()
        if (searchType == 1 && selectedCenter == 0) {
            toast.open("Please select center", <MdErrorOutline />, "danger")
            setLoding(false);
            return;
        }
        Dashboard({
            fromDate: moment(new Date(value.startDate)).format("MM/DD/YYYY"),
            toDate: moment(new Date(value.endDate)).format("MM/DD/YYYY"),
            centerId: searchType == 1 ? selectedCenter : 0,
            isCenter: searchType
        })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    if (searchType == 0)
                        setReportData(mdata.global);
                    else
                        setReportData(mdata.center);
                } else {
                    setReportData(initReport);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setReportData(initReport);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)

            });
    }

    const doRefresh = () => {
        getReport()
        getAllOpdCenters();
    }
    return (
        <ContainerTwo>
            <Getbalance />
            <Card title={"DashBoard"} isBorder={true} borderColor='border-sky-300' isRefresh={true} doRefresh={doRefresh}>
                <div className='flex flex-col justify-between sm:flex-row sm:items-end sm:space-x-4 space-y-4 sm:space-y-0'>

                    {/* First Dropdown */}
                    <div className='w-full '>
                        <label className="block mb-1 text-sm font-medium text-gray-700">Select</label>
                        <Select
                            Icon={<HiDocumentReport className='text-sky-600 text-lg' />}
                            value={searchType}
                            onChange={(e) => setSearchType(Number(e.target.value))}
                        >
                            <option value={0}>All</option>
                            <option value={1}>Centers</option>
                        </Select>
                    </div>

                    {/* Conditional Second Dropdown */}
                    {searchType !== 0 && (
                        <div className='w-full'>
                            <label className="block mb-1 text-sm font-medium text-gray-700">Select Center</label>
                            <Select
                                Icon={<FaClinicMedical className='text-red-600 text-lg' />}
                                value={selectedCenter}
                                onChange={(e) => setSelectedCenter(e.target.value)}
                            >
                                <option value={0}>Select Center...</option>
                                {centerData.map(item => (
                                    <option key={item.id} value={item.id}>{item.centerName}</option>
                                ))}
                            </Select>
                        </div>
                    )}

                    {/* Date Picker */}
                    <div className='w-full'>
                        <label className="block mb-1 text-sm font-medium text-gray-700">Date Range</label>
                        <Datepicker
                            popoverDirection='down'
                            displayFormat="DD/MM/YYYY"
                            readOnly={true}
                            separator="to"
                            primaryColor={"sky"}
                            value={value}
                            onChange={newValue => setValue(newValue)}
                            showShortcuts={true}
                            inputClassName="outline-blue-400 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                        />
                    </div>
                    <button onClick={getReport} type="submit" class="p-3 text-sm font-medium text-white bg-sky-500 rounded-lg border border-sky-600 hover:bg-sky-600 focus:ring-4 focus:outline-none focus:ring-sky-300">
                        <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                        <span class="sr-only">Search</span>
                    </button>
                </div>

            </Card>

            <div className="w-full flex items-center justify-center pt-10">
                {loding ?
                    <div className='w-full'>
                        <Card isBorder={true} borderColor='border-gray-400' title={"Report"}>
                            <LoadingContainer text="Please wait..." />
                        </Card>
                    </div>
                    :
                    <div className="grid grid-cols md:grid-cols-2 gap-6 w-full">
                        <Card isBorder={true} borderColor='border-green-400' title={"All Registered Patient"}>
                            <div className='overflow-x-auto rounded-lg'>
                                <table class="border w-full text-sm text-left rtl:text-right text-gray-500  ">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                        <tr>
                                            <th scope="col" class="px-6 py-3">
                                                Source
                                            </th>
                                            <th scope="col" class="px-6 py-3 ">
                                                Count
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loding ?
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td colSpan={2}>
                                                    <LoadingContainer text="Fetching..." />
                                                </td>
                                            </tr>
                                            :
                                            reportData.registeredGlobal.length > 0 ?
                                                reportData.registeredGlobal.map(item =>
                                                    <tr class="bg-white border-b hover:bg-gray-100">
                                                        <td class="px-6 py-2">
                                                            <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
                                                        </td>
                                                        <td class="px-6 py-2">
                                                            {item.count}
                                                        </td>
                                                    </tr>
                                                )
                                                :
                                                <tr class="bg-white border-b hover:bg-gray-100">
                                                    <td colSpan={2} class="px-3 py-2">
                                                        <Empty>
                                                            <div className='text-xl'>
                                                                No Items Found.
                                                            </div>
                                                        </Empty>
                                                    </td>
                                                </tr>
                                        }
                                        <tr className="bg-gray-100 border-b font-semibold text-gray-800">

                                            <td className="px-6 py-2 text-right pr-[0px]">
                                                Total:
                                            </td>
                                            <td className="px-6 py-2 text-left">
                                                {reportData.registeredGlobal.reduce((sum, item) => sum + item.count, 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Card>

                        <Card isBorder={true} borderColor='border-green-400' title={"All Confirmed Patient"}>
                            <div className='overflow-x-auto rounded-lg'>
                                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                        <tr>
                                            <th scope="col" class="px-6 py-3">
                                                Source
                                            </th>
                                            <th scope="col" class="px-6 py-3">
                                                Type
                                            </th>
                                            <th scope="col" class="px-6 py-3 ">
                                                Count
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loding ?
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td colSpan={3}>
                                                    <LoadingContainer text="Fetching..." />
                                                </td>
                                            </tr>
                                            :
                                            reportData.confirmedGlobal.length > 0 ?
                                                reportData.confirmedGlobal.map(item =>
                                                    <tr class="bg-white border-b hover:bg-gray-100">
                                                        <td class="px-6 py-2">
                                                            <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
                                                        </td>
                                                        <td class="px-6 py-2">
                                                            <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
                                                        </td>
                                                        <td class="px-6 py-2">
                                                            {item.count}
                                                        </td>
                                                    </tr>
                                                )
                                                :
                                                <tr class="bg-white border-b hover:bg-gray-100">
                                                    <td colSpan={3} class="px-3 py-2">
                                                        <Empty>
                                                            <div className='text-xl'>
                                                                No Items Found.
                                                            </div>
                                                        </Empty>
                                                    </td>
                                                </tr>
                                        }
                                        <tr className="bg-gray-100 border-b font-semibold text-gray-800">
                                            <td className="px-6 py-2">
                                            </td>
                                            <td className="px-6 py-2 text-right pr-[0px]">
                                                Total:
                                            </td>
                                            <td className="px-6 py-2 text-left">
                                                {reportData.confirmedGlobal.reduce((sum, item) => sum + item.count, 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Card>

                        <Card isBorder={true} borderColor='border-sky-300' title={"Confirmed Patient by Source"}>
                            <div className='overflow-x-auto rounded-lg'>
                                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                        <tr>
                                            <th scope="col" class="px-6 py-3">
                                                Source
                                            </th>
                                            <th scope="col" class="px-6 py-3 ">
                                                Count
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loding ?
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td colSpan={2}>
                                                    <LoadingContainer text="Fetching..." />
                                                </td>
                                            </tr>
                                            :
                                            reportData.confirmedSource.length > 0 ?
                                                reportData.confirmedSource.map(item =>
                                                    <tr class="bg-white border-b hover:bg-gray-100">
                                                        <td class="px-6 py-2">
                                                            <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
                                                        </td>
                                                        <td class="px-6 py-2">
                                                            {item.count}
                                                        </td>
                                                    </tr>
                                                )
                                                :
                                                <tr class="bg-white border-b hover:bg-gray-100">
                                                    <td colSpan={2} class="px-3 py-2">
                                                        <Empty>
                                                            <div className='text-xl'>
                                                                No Items Found.
                                                            </div>
                                                        </Empty>
                                                    </td>
                                                </tr>
                                        }
                                        <tr className="bg-gray-100 border-b font-semibold text-gray-800">
                                            <td className="px-6 py-2 text-right pr-[0px]">
                                                Total:
                                            </td>
                                            <td className="px-6 py-2 text-left">
                                                {reportData.confirmedSource.reduce((sum, item) => sum + item.count, 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Card>

                        <Card isBorder={true} borderColor='border-sky-300' title={"Confirmed Patient by Type"}>
                            <div className='overflow-x-auto rounded-lg'>
                                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                        <tr>
                                            <th scope="col" class="px-6 py-3">
                                                Type
                                            </th>
                                            <th scope="col" class="px-6 py-3 ">
                                                Count
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loding ?
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td colSpan={2}>
                                                    <LoadingContainer text="Fetching..." />
                                                </td>
                                            </tr>
                                            :
                                            reportData.confirmedType.length > 0 ?
                                                reportData.confirmedType.map(item =>
                                                    <tr class="bg-white border-b hover:bg-gray-100">
                                                        <td class="px-6 py-2">
                                                            <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
                                                        </td>
                                                        <td class="px-6 py-2">
                                                            {item.count}
                                                        </td>
                                                    </tr>
                                                )
                                                :
                                                <tr class="bg-white border-b hover:bg-gray-100">
                                                    <td colSpan={2} class="px-3 py-2">
                                                        <Empty>
                                                            <div className='text-xl'>
                                                                No Items Found.
                                                            </div>
                                                        </Empty>
                                                    </td>
                                                </tr>
                                        }
                                        <tr className="bg-gray-100 border-b font-semibold text-gray-800">

                                            <td className="px-6 py-2 text-right pr-[0px]">
                                                Total:
                                            </td>
                                            <td className="px-6 py-2 text-left">
                                                {reportData.confirmedType.reduce((sum, item) => sum + item.count, 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </div>
                }
            </div>
        </ContainerTwo>
    )
}
